<div class="content pb-0" *ngIf="is_ignite == true">
    <mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="onTabClick($event)">
        <mat-tab label="Dashboard"></mat-tab>
        <mat-tab label="Billing Address"></mat-tab>
        <mat-tab label="Payment Methods"></mat-tab>
        <mat-tab label="Subscription"></mat-tab>
        <mat-tab label="Transactions"></mat-tab>
    </mat-tab-group>
</div>